import { useState } from 'react';

export function useExportCsv() {
    const [isExporting, setisExporting] = useState(false);

    const exportCsv = async (endpoint: string, params: object): Promise<void> => {
        setisExporting(true);

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
            });

            if (!response.ok) throw new Error('Failed to export file');

            const blob = await response.blob();

            let filename = 'export.csv';
            const disposition = response.headers.get('Content-Disposition');

            if (disposition?.includes('filename=')) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, '');
                }
            }

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Export failed:', error);
        } finally {
            setisExporting(false);
        }
    };

    return { exportCsv, isExporting };
}
